module.exports = __webpack_public_path__ + "img/plus.c0bba464.svg";